import React from "react";
import { Link } from "react-router-dom";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

const Home = () => {
  const pages = [
    {
      title: "Charity Tournament",
      description: "Book professional highlight edits for the charity tournament.",
      path: "/tournament",
      label: "View Tournament",
      image: "/images/sudan_round_icon.png",
      tag: "Tournament",
    },
    {
      title: "MNF Highlights",
      description:
        "Explore Monday Night Football media packages and highlight services.",
      path: "/mnf",
      label: "View MNF",
      image: "/images/MNF.png",
      tag: "Football Media",
    },
    {
      title: "ChickenLicious Tournament",
      description: "Book professional highlight edits for the tournament.",
      path: "/chickenLicious",
      label: "View Tournament",
      image: "/images/chickenLicious.png",
      tag: "Tournament",
    },
  ];

  return (
    <>
      <Navbar />

      <main className="w-full">
        {/* Events Hero */}
        <section
          id="events"
          className="mx-auto max-w-[1200px] px-4 pt-5 pb-12 md:pt-10 md:pb-16"
        >
          <div className="mb-6 rounded-3xl border border-blue-200 bg-slate-950 p-5 shadow-[0_12px_35px_rgba(37,99,235,0.12)] md:mb-8 md:p-10">
            <div className="flex flex-col gap-5 md:flex-row md:items-end md:justify-between">
              <div>
                <span className="hidden md:block inline-flex rounded-full border border-blue-300 bg-blue-500/10 px-3 py-1 text-xs font-semibold text-blue-200 md:px-4 md:text-sm">
                  Student Ball Media
                </span>

                <h1 className="md:mt-4 text-3xl font-extrabold tracking-tight text-white md:mt-5 md:max-w-3xl md:text-6xl">
                  Events
                </h1>

                <p className=" md:block mt-3 max-w-2xl text-sm leading-6 text-slate-300 md:mt-4 md:text-lg md:leading-7">
                  Choose an event to book highlights, media coverage, or tournament content.
                </p>
              </div>

              <a
                href="#about"
                onClick={(e) => {
                  e.preventDefault();
                  document
                    .getElementById("about")
                    ?.scrollIntoView({ behavior: "smooth", block: "start" });
                }}
                className="hidden md:block inline-flex w-fit rounded-full border border-white/20 px-5 py-2.5 text-sm font-semibold text-white transition hover:bg-white/10 md:px-6 md:py-3 md:text-base"
              >
                About Student Ball
              </a>
            </div>
          </div>
          <div className="grid grid-cols-1 gap-6 md:grid-cols-3">
            {pages.map((page) => (
              <Link
                key={page.path}
                to={page.path}
                onClick={() => window.scrollTo(0, 0)}
                className="group overflow-hidden rounded-2xl border border-slate-200 bg-white p-6 shadow-sm transition hover:-translate-y-1 hover:border-blue-300 hover:shadow-[0_12px_35px_rgba(37,99,235,0.12)]"
              >
                <div className="flex items-center justify-between gap-4">
                  <div className="flex h-16 w-16 items-center justify-center rounded-2xl bg-slate-50">
                    <img
                      src={page.image}
                      alt={page.title}
                      className="h-12 w-12 object-contain"
                    />
                  </div>

                  <span className="rounded-full bg-blue-50 px-3 py-1 text-xs font-semibold text-blue-700">
                    {page.tag}
                  </span>
                </div>

                <h3 className="mt-6 text-2xl font-bold text-slate-900">
                  {page.title}
                </h3>

                <p className="mt-3 text-sm leading-6 text-slate-600">
                  {page.description}
                </p>

                <div className="mt-6 inline-flex items-center font-semibold text-blue-600">
                  {page.label}
                  <span className="ml-2 transition group-hover:translate-x-1">
                    →
                  </span>
                </div>
              </Link>
            ))}
          </div>
        </section>

        {/* About Us */}
        <section id="about" className="mx-auto max-w-[1200px] px-4 pb-20">
          <div className="grid grid-cols-1 gap-8 rounded-3xl border border-slate-200 bg-white p-6 shadow-sm md:grid-cols-[1fr_1.2fr] md:p-10">
            <div className="rounded-2xl bg-slate-950 p-8 text-white">
              <img
                src="/images/ball_logo.png"
                alt="Student Ball logo"
                className="h-20 w-20 object-contain"
              />

              <h2 className="mt-6 text-3xl font-bold">About Student Ball</h2>

              <p className="mt-4 text-slate-300">
                Sports media built for players and teams trying to be seen.
              </p>
            </div>

            <div className="flex flex-col justify-center">
              <span className="text-sm font-semibold uppercase tracking-wide text-blue-600">
                What we do
              </span>

              <h3 className="mt-3 text-3xl font-bold text-slate-900">
                We help grassroots talent turn matchday moments into recognition.
              </h3>

              <p className="mt-4 leading-7 text-slate-600">
                Student Ball provides professional media coverage, highlight
                edits and event content for amateur and semi-professional sports.
                Whether it is a tournament, a weekly football night or a team
                showcase, we capture the moments that matter and present them in
                a way that players can share, promote and be proud of.
              </p>

              <div className="mt-6 grid grid-cols-1 gap-4 sm:grid-cols-3">
                <div className="rounded-2xl bg-blue-50 p-4">
                  <p className="text-2xl font-bold text-blue-600">01</p>
                  <p className="mt-1 text-sm font-semibold text-slate-700">
                    Capture
                  </p>
                </div>

                <div className="rounded-2xl bg-blue-50 p-4">
                  <p className="text-2xl font-bold text-blue-600">02</p>
                  <p className="mt-1 text-sm font-semibold text-slate-700">
                    Edit
                  </p>
                </div>

                <div className="rounded-2xl bg-blue-50 p-4">
                  <p className="text-2xl font-bold text-blue-600">03</p>
                  <p className="mt-1 text-sm font-semibold text-slate-700">
                    Get Seen
                  </p>
                </div>
              </div>

              <a
                href="#events"
                onClick={(e) => {
                  e.preventDefault();
                  document
                    .getElementById("events")
                    ?.scrollIntoView({ behavior: "smooth", block: "start" });
                }}
                className="mt-8 inline-flex w-fit rounded-full bg-slate-900 px-6 py-3 font-semibold text-white transition hover:bg-blue-600"
              >
                View Events
              </a>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
};

export default Home;